/**
 * Listen for HubSpot form postMessage and call the async trackFn when the
 * specified form is submitted.
 *
 * Matches messages where:
 *  - event.data.type === "hsFormCallback"
 *  - event.data.eventName === "onFormSubmit"
 *  - event.data.id === hubSpotFormId
 *
 * Returns a cleanup function to remove the event listener and prevent memory leaks.
 *
 * @param hubSpotFormId - HubSpot form ID to match
 * @param trackFn - Async callback invoked on submit
 * @returns Cleanup function to remove the event listener
 */
export const registerHubspotFormSubmitListener = (
  hubSpotFormId: string,
  trackFn: () => Promise<void>
): (() => void) => {
  const handler = async (event: MessageEvent) => {
    if (
      event.data.type === "hsFormCallback" &&
      event.data.eventName === "onFormSubmit" &&
      event.data.id === hubSpotFormId
    ) {
      await trackFn();
    }
  };

  window.addEventListener("message", handler);

  // Return cleanup function
  return () => {
    window.removeEventListener("message", handler);
  };
};
